import { Routes } from '@angular/router';
import { FaqService } from './faq.service';

export const FAQ_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./faq.component').then(c => c.FaqComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./faq-area/faq-area.component').then(c => c.FaqAreaComponent),
      },
      {
        path: ':area',
        loadComponent: () => import('./faq-section/faq-section.component').then(c => c.FaqSectionComponent),
      },
      {
        path: ':area/:section',
        loadComponent: () => import('./faq-body/faq-body.component').then(c => c.FaqBodyComponent),
      },
    ],
    providers: [FaqService],
  },
];
